import { render } from "./node.vue?vue&type=template&id=0c4e5808&scoped=true&ts=true"
import script from "./node.vue?vue&type=script&lang=ts"
export * from "./node.vue?vue&type=script&lang=ts"

import "./node.vue?vue&type=style&index=0&id=0c4e5808&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c4e5808"]])

export default __exports__